webpackJsonp([232381552773310],{

/***/ 211:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(11);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _reactReveal = __webpack_require__(18);
	
	var _reactAnchorLinkSmoothScroll = __webpack_require__(45);
	
	var _reactAnchorLinkSmoothScroll2 = _interopRequireDefault(_reactAnchorLinkSmoothScroll);
	
	var _SiteConfig = __webpack_require__(5);
	
	var _SiteConfig2 = _interopRequireDefault(_SiteConfig);
	
	var _SEO = __webpack_require__(24);
	
	var _SEO2 = _interopRequireDefault(_SEO);
	
	var _Footer = __webpack_require__(16);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	var _Container = __webpack_require__(23);
	
	var _Container2 = _interopRequireDefault(_Container);
	
	var _hero = __webpack_require__(31);
	
	var _hero2 = _interopRequireDefault(_hero);
	
	var _pageModule = __webpack_require__(53);
	
	var _pageModule2 = _interopRequireDefault(_pageModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Page = function Page() {
	  return _react2.default.createElement(
	    'div',
	    { className: 'container project-container' },
	    _react2.default.createElement(_reactHelmet2.default, { title: '' + _SiteConfig2.default.siteTitle }),
	    _react2.default.createElement(
	      'div',
	      { className: _pageModule2.default.headerWrapper, style: { color: 'white', marginTop: '0' } },
	      _react2.default.createElement(_hero2.default, { cover: '../pictures/sella/hero.jpg', title: 'Sella Chair', link: '#content' })
	    ),
	    _react2.default.createElement(
	      'div',
	      { style: { display: 'flex', flexDirection: 'row' } },
	      _react2.default.createElement(
	        'p',
	        { id: 'content', style: { width: '30%', marginLeft: '18%' } },
	        'The Sella Chair is a technology demonstrator designed to put to the test Digital Architects\u2019 wood-carbon composites, known as \u201CActive Grid Monocoque System\u201D (AGM System). It showcases the complete package from Digital Architects\u2019 vision, their successful use of'
	      ),
	      _react2.default.createElement(
	        'p',
	        { style: { width: '30%', marginRight: '18%' } },
	        'Altair\u2019s HyperWorks structural design and optimization software suite, coupled with hands-on engineering and proving of manufacturing processes, by evaluating the structural performance along on a scale that is closer to architectural requirements.'
	      )
	    ),
	    _react2.default.createElement('img', { src: '../pictures/sella/first.jpg', alt: 'Construction of the Sella Chair', style: { width: '100%' } }),
	    _react2.default.createElement('img', { src: '../pictures/sella/diagram.jpg', alt: 'Diagrams explaining the Chair' }),
	    _react2.default.createElement(
	      'div',
	      { style: { display: 'flex', flexDirection: 'row', marginTop: '3%' } },
	      _react2.default.createElement(
	        'p',
	        { id: 'content', style: { width: '30%', marginLeft: '18%' } },
	        'The Sella Chair is made of Digital Architects\u2019 AGM system wood-carbon composites: a laminated structure comprising of thin wood veneers, with layers of carbon fiber interspersed between them'
	      ),
	      _react2.default.createElement(
	        'p',
	        { style: { width: '30%', marginRight: '18%' } },
	        'all adhesively-bonded together: a classic pa\u030Aly-wood-type construction, but with a modern twist provided by an advanced composite reinforcement to enhance structural performance.'
	      )
	    ),
	    _react2.default.createElement('img', {
	      src: '../pictures/sella/second.jpg',
	      alt: 'Construction of the chair on a workbench',
	      style: { width: '100%' }
	    }),
	    _react2.default.createElement(_Footer2.default, null)
	  );
	};
	exports.default = Page;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-sella-jsx-cfd4bbbad116fb6e97c9.js